import Footer from "@/components/Footer";
import { Dimmer } from "@/components/spinner";
import useTableService from "@/components/useTableServerSide";
import { SearchInput } from "@/ui/inputs/Input";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { EstadoCuentaRentas } from "./modalEstadoCuentaEjido";
const headCells = [
  {
    id: "",
    label: "CODIGO",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "CEDULA/RIF",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "NOMBRE ARRENDATARIO",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "RENTA",
    width: "200px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "",
    label: "OPCIONES",
    width: "60px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];
export function TablaEstadoCuenta(props) {
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const anioactu = JSON.parse(localStorage.getItem("anioactu"));
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const searchTimeoutRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [mostrar5, setMostrar5] = useState(false);
  const [valorUT, setValorUT] = useState();
  const [inmobiliaria, setInmobiliaria] = useState();
  const [rentas, setRentas] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [factorCambio, setFactorCambio] = useState(0);
  const [credito, setCredito] = useState();
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
    onSortChange: (orderBy, orderDir) =>
      setTableState((prev) => ({ ...prev, orderBy, orderDir, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );
  const buscarRegistros = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
    };
    const endpoint = `${op.conexion}/api/aseo/estado-cuenta-rentas-inmobiliarias`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };
  const seleccionarRegistro = (idrentas) => (e) => {
    e.preventDefault();

    let campos = "*";
    let nomtab = "rentasinmobiliarias";
    let nomid = "idrentas";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idrentas}&nomtab=${nomtab}&nomid=${nomid}`;
    setLoading(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idrentas > 0) {
            setInmobiliaria(response.data);
            if (response.data.tipotabla === 0) {
              seleccionarRegistroInmueble(response.data);
              blanquearCampos;
            } else if (response.data.tipotabla === 1) {
              seleccionarRegistroComercio(response.data);
              blanquearCampos;
            } else {
              seleccionarRegistroTP(response.data);
            }
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setLoading(false);
      });
  };

  const seleccionarRegistroInmueble = (data) => {
    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setLoading(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idinmueble > 0) {
            seleccionarRegistroTP(data);
            setCredito(response.data.credito);
          } else {
            seleccionarRegistroTP(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setLoading(false);
      });
  };
  const seleccionarRegistroComercio = (data) => {
    let campos = "*";
    let nomtab = "comercio";
    let nomid = "idcomercio";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setLoading(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcomercio > 0) {
            setCredito(response.data.credito);
            seleccionarRegistroTP(data);
          } else {
            seleccionarRegistroTP(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setLoading(false);
      });
  };

  const seleccionarRegistroTP = (data) => {
    let campos = "*";
    let nomtab = "tiporentas";
    let nomid = "idtiporentas";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idtiporenta}&nomtab=${nomtab}&nomid=${nomid}`;
    setLoading(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtiporentas > 0) {
            setRentas(response.data);
            console.log(response.data.descripcion);
            SelectDeudaC(data.idrentas);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setLoading(false);
      });
  };

  const SelectDeudaC = (idrentas) => {
    let tabla = "aseo";
    let endpoint = "";
    if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    } else {
      endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    }
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var mesactu = (new Date(fechaSistema).getMonth() + 1)
            .toString()
            .padStart(2, 0);
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].fechapago === null &&
              response.data[i].estatus === "Por Pagar" &&
              parseInt(response.data[i].nmes) <= parseInt(mesactu)
            ) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu, //* factorCambio,
                intereses: response.data[i].intmoradeu * factorCambio,
                multa: response.data[i].multa * factorCambio,
                recargo: response.data[i].recargodeu * factorCambio,
              });
            } else if (
              response.data[i].fechapago !== null &&
              response.data[i].estatus === "Pagada"
            ) {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
          setMostrar5(true);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setLoading(false);
      });
  };
  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setLoading(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const seleccionarValorPetro = () => {
    let endpoint = op.conexion + "/api/efiscal/valorpetro";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValorUT(response.data.valor);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquearCampos = () => {
    setLoading(false);
    setInmobiliaria();
    setDeuda();
    setHistorico();
  };
  const cerrar = () => {};
  useEffect(() => {
    seleccionarFactorCambio();
    seleccionarValorPetro();
  }, []);
  useEffect(() => {
    const cleanup = buscarRegistros();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);
  return (
    <div className="col-8">
      <div className="col-12 py-2 border rounded mx-auto">
        <header className="col-12 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
          <h3 className="fw-bold text-light m-0">
            Gestion de Estado de Cuenta Rentas Inmobiliarias
          </h3>
          <button onClick={() => cerrar()} className="btn btn-sm bg-light">
            <i className="fa fa-times"></i>
          </button>
        </header>
        <div className="col-4 m-0 my-2 p-0">
          <SearchInput
            className="search-input pe-4"
            value={searchInput}
            onChange={handleSearch}
          />
        </div>
        <section className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                records.map((item, index) => (
                  <tr key={index} style={{ padding: "0" }}>
                    <td
                      className="align-baseline"
                      style={{
                        textAlign: "center",
                        width: "10px",
                        fontSize: "11px",
                      }}
                    >
                      {item.idrentas}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        textAlign: "center",
                        width: "100px",
                        fontSize: "11px",
                      }}
                    >
                      {item.cedrif}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        textAlign: "center",
                        width: "auto",
                        fontSize: "11px",
                      }}
                    >
                      {item.nombrearrendatario}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        textAlign: "center",
                        width: "auto",
                        fontSize: "11px",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="align-baseline"
                      style={{
                        textAlign: "center",
                        width: "10px",
                        fontSize: "11px",
                      }}
                    >
                      <button
                        onClick={seleccionarRegistro(item.idrentas)}
                        className="btn btn-sm btn-info rounded-pill"
                      >
                        <i className="fas fa-search">Consultar</i>{" "}
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </section>
      </div>
      <Dimmer active={loading} inverted />
      <Footer />
      <EstadoCuentaRentas
        factorCambio={factorCambio}
        show={mostrar5}
        onHideCancela={() => setMostrar5(false)}
        deuda={deuda}
        historico={historico}
        inmobiliaria={inmobiliaria}
        rentas={rentas}
        valorUT={valorUT}
        credito={credito}
      />
    </div>
  );
}
